/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'bootstrap'
import $ from 'jquery'
import Rails from '@rails/ujs'
import select2 from 'select2/dist/js/select2.full'

import '../js/ospe-public/i18n'
import '../js/site'
import '../js/admin/users'
import '../js/admin/ospe-ncps'
import '../js/candidates'
import '../js/instructors'
import '../js/events'
import '../js/event-teams'
import '../js/candidates-import-batches'
import '../js/participant-registration'
import '../js/events-import-batches'
import '../js/data-import-batches'
import '../js/reimbursement'
import '../js/admin/surveys'
import '../js/admin/mail-messages'
import '../js/event-reimbursements'
import '../js/completion-certificates'
import '../js/admin/ospe'

import '../js/completion-certificate-templates'
import '../js/reports'
import '../js/external-events'
import '../js/back-office/event-emails'

import '../js/ospe-activities'
import '../js/ospe-participants'
import '../js/ospe-activity-reimbursement'
import '../js/ospe-reports'
import '../js/ospe-activity-emails'
import '../js/ospe-survey-results'
import {initSentry} from "@/js/sentry";

initSentry()
if (!window.Rails) Rails.start() // https://github.com/ElMassimo/vite_ruby/issues/246#issuecomment-1235743299
select2()
// select2 4.1.0 passes SelectAdapter.prototype._normalizeItem unbound to Array#map
// for AJAX results and option children. Vite loads select2 as a strict ES module,
// so `this` is undefined there and every AJAX response fails with
// "The results could not be loaded".
const SelectAdapter = $.fn.select2.amd.require('select2/data/select')
const normalizeItem = SelectAdapter.prototype._normalizeItem
SelectAdapter.prototype._normalizeItem = function (this: unknown, item: unknown): unknown {
  return normalizeItem.call(this ?? {}, item)
}
$.fn.select2.defaults.set('theme', 'bootstrap-5')
